// extracted by mini-css-extract-plugin
export default {"infoButton":"InfoButton_infoButton__g46j8"};